<template>
  <ProductionOrderEmbeddable v-model="form"/>
</template>
<script>
import productionOrderEmbeddableMixin from "@/mixins/embeddable/production/productionOrderEmbeddableMixin"

export default {
  name: 'ProductionOrder',
  mixins: [productionOrderEmbeddableMixin],
  data() {
    return {
      form: {},
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
}
</script>
